import { render } from "./SnsConnectionSettingForm.vue?vue&type=template&id=c053cadc"
import script from "./SnsConnectionSettingForm.vue?vue&type=script&lang=js"
export * from "./SnsConnectionSettingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__